import CollectionBase from 'common/base/collection-base';
import IntensityReportModel from 'common/models/intensity-report-model';
import IntensityReportURL from 'common/urls/intensity-report-url';
import {t} from 'common/utils/translation-util';

export default CollectionBase.extend({
  getIntensity(systemName) {
    const results = this.getAttribute('results');
    if (results) {
      const result = results[systemName];
      if (result && result.hasOwnProperty('intensity')) {
        return result.intensity;
      }
    }
  },
  initialize() {
    this.errorMessage = t('Intensity data failed to load.');
    this.model = IntensityReportModel;
    this.urlFunc = IntensityReportURL;
  },
});
